import React, { Dispatch } from 'react'
import { Button, DatePicker, Select, Spin, Tooltip } from "antd"
import { LoadingOutlined, InfoCircleOutlined } from '@ant-design/icons';
import WeeklyChart from "../charts/WeeklyChart"
import GaugeChart from 'react-gauge-chart'
import { IRejectedRate } from '../interface/interface';
import 'moment/locale/fr';
import locale from 'antd/es/date-picker/locale/fr_FR';

const { Option } = Select;

const dotStyle = (color: string) => ({
  width: '10px',
  height: '10px',
  backgroundColor: color,
  borderRadius: '50%',
  marginRight: '10px',
  display: 'inline-block',
});

export const BP = (props: { count: { count: number }, loading: boolean }) => (
  <div >
    <Spin spinning={props.loading} indicator={<LoadingOutlined />}>
      <div id="current-bp" className='global-view-card-title'>
        {window.location.pathname === "/activity_report" &&
          <div style={dotStyle("#10b981")}></div>}
        {props.count.count > 1 ? "BP terminés" : "BP terminé"}
      </div>
      <div id="current-count" className='global-view-card-BP'>{props.count.count}</div>
      <div className='global-view-card-description'>Sur la période</div>
    </Spin>
  </div>
)

export const Errors = (props: { count: { count: number }, loading: boolean }) => (
  <div>
    <Spin spinning={props.loading} indicator={<LoadingOutlined />}>
      <div className='global-view-card-title'>{props.count.count > 1 ? "Plateaux en attente" : "Plateau en attente"}</div>
      <div id="error-tray" className='global-view-card-error'>{props.count.count}</div>
      <div className='global-view-card-description'>{props.count.count > 1 ? "erreurs non résolues" : "erreur non résolue"}</div>
    </Spin>
  </div>
)

export const TrayScanned = (props: { count: { ia: number }, loading: boolean }) => (
  <div>
    <Spin spinning={props.loading} indicator={<LoadingOutlined />} >
      <div className='global-view-card-title'>
        {window.location.pathname === "/activity_report" &&
          <div style={dotStyle("#1890ff")}></div>
        }
        {"Plateau IA"}</div>
      <div id="scanned-tray" className='global-view-card-tray'>{props.count.ia ?? 0}</div>
      <div className='global-view-card-description'>Sur la période</div>
    </Spin>
  </div>
)

export const BraceletScanned = (props: { count: { braceletCount: number }, loading: boolean }) => (
  <div>
    <Spin spinning={props.loading} indicator={<LoadingOutlined />} >
      <div className='global-view-card-title'>{props.count.braceletCount > 1 ? "Bracelets scannés" : "Bracelet scanné"}</div>
      <div id="scanned-tray" className='global-view-card-tray'>{props.count.braceletCount}</div>
      <div className='global-view-card-description'>Sur la période</div>
    </Spin>
  </div>
)

export const WeeklyCount = (props: { count: { _id: string, count: number }, loading: boolean }) => (
  <div>
    <Spin spinning={props.loading} indicator={<LoadingOutlined />} >
      <div className='global-view-card-title'>Comptage semaine</div>
      <WeeklyChart count={props.count} />
    </Spin>
  </div>
)

export const ErrorToday = (props: { count: { forced: number }, loading: boolean }) => (
  <div id={"error-today"}>
    <Spin spinning={props.loading} indicator={<LoadingOutlined />} >
      <div className='global-view-card-title'>
        <div style={dotStyle("#faa501")}></div>
        {props.count.forced > 1 ? "Plateaux forcés" : "Plateau forcé"}
        <Tooltip title="Plateau validé par l’utilisateur après suspicion d’erreur remontée par l’IA">
          <Button type="ghost" style={{ marginLeft: "1rem", borderColor: "transparent", boxShadow: "none" }} shape="circle" icon={<InfoCircleOutlined />} />
        </Tooltip>
      </div>
      <div id={"error-today-count"} className='global-view-card-error'>{props.count.forced}</div>
      <div className='global-view-card-description'>Sur la période</div>
    </Spin>
  </div>
)

export const AverageTime = (props: { average: string, setAverageDate: Dispatch<moment.Moment>, averageDate: moment.Moment }) => (
  <div className='card-average-time'>
    <h2 className='average-time-title'>Temps moyen de resolution d'erreurs</h2>
    <h1 className='average-time-time'>{props.average}</h1>
    <div className='average-time-select'>
      <DatePicker picker='month' onChange={(event) => { if (event) props.setAverageDate(event) }} format="MMM YYYY" value={props.averageDate} locale={locale} />
    </div>
  </div>
)

export const ManualTray = (props: { count: { manual: number }, loading: boolean }) => (
  <div>
    <div className='global-view-card-title'>
      <div style={dotStyle("#f96384")}></div>
      {props.count.manual > 1 ? "Plateaux manuels" : "Plateau manuel"}
      <Tooltip title="Plateau validé sans vérification par l’IA">
        <Button type="ghost" style={{ marginLeft: "1rem", borderColor: "transparent", boxShadow: "none" }} shape="circle" icon={<InfoCircleOutlined />} />
      </Tooltip>
    </div>
    <div id={"error-today-count"} className='global-view-card-error'>{props.count.manual}</div>
    <div className='global-view-card-description'>Sur la période</div>
  </div >
)

const formatNum = (num: number) => {
  let number = Number(num)
  return Math.round(number * 100) / 100
}

export const Rejected = (props: { percent: IRejectedRate | undefined, loading: boolean, setSelected: Dispatch<string>, selected: string }) => (
  <>
    <div className='global-view-card-title'>Taux de rejet
      <Tooltip title="Nombre de plateaux forcés divisé par le total de plateaux scannés">
        <Button type="ghost" style={{ marginLeft: "1rem", borderColor: "transparent", boxShadow: "none" }} shape="circle" icon={<InfoCircleOutlined />} />
      </Tooltip>
    </div>
    <Spin spinning={props.loading} indicator={<LoadingOutlined />} >
      <GaugeChart id="rejected-gauge"
        nrOfLevels={1}
        colors={["#8b5cf6"]}
        cornerRadius={4}
        needleColor={"#5d5fef"}
        textColor={"black"}
        animate={false}
        percent={props.percent ? formatNum(((props?.percent?.error / (props?.percent?.success)))) : 0}
      />
    </Spin>
  </>
)